import React from 'react';
import { Text, TextHtmlTags, TextVariants } from '../../../../../atoms/text';
var PCSD = function (_a) {
    var description = _a.description;
    return description ? (React.createElement(Text, { content: description, component: TextHtmlTags.P, variant: TextVariants.Body2 })) : null;
};
export { PCSD as ProductCardShortDescription };
